import {mainnet} from '@wagmi/core';
import * as supportChains from '@wagmi/core/chains';
import {walletMetas} from '@/const/wallet-connect';

export const chains = Object.values(supportChains);

export const connectChainId = mainnet.id;

export const walletIds = [walletMetas.imToken.id, walletMetas.zerion.id, walletMetas.trustWallet.id];

/**
 * 读取钱包类型
 */
export function readWalletConnectOriginName() {
  try {
    let originName = '';

    const data1 = localStorage.getItem('W3M_RECENT_WALLET_DATA');
    if (data1) {
      const item1: any = Object.values(JSON.parse(data1));
      originName = item1?.[0]?.name;
    }
    if (originName && originName !== 'WalletConnect') {
      return originName;
    }
    const data2 = localStorage.getItem('wc@2:client:0.3//session');
    const item2 = data2 ? JSON.parse(data2) : {};
    const safeWalletName = formatWalletName(item2?.[0]?.peer?.metadata?.name);
    return safeWalletName || 'WalletConnect';
  } catch (error) {
    return 'WalletConnect';
  }
}

function formatWalletName(walletName) {
  return (walletName || '').replace(/Wallet$/i, '').trim();
}
